import { Component, inject, input, InputSignal } from '@angular/core';
import { IUser } from '../../../../api/mylb/interfaces/iuser.interface';
import { FormGroup } from '@angular/forms';
import { ProfileSupportDataStateService } from '../../profile-support-data-state.service';
import { toObservable, takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';

@Component({
	selector: 'lb-profile-info-box-base',
	template: ''
})
export class ProfileInfoBoxBaseComponent {
	public _profileSupportDateStateService: ProfileSupportDataStateService = inject(ProfileSupportDataStateService);

	public profile: InputSignal<IUser> = input.required<IUser>();
	public form: InputSignal<FormGroup> = input.required<FormGroup>();
	public isLearner: InputSignal<boolean | undefined> = input<boolean>();
	public formDisabled: InputSignal<boolean | undefined> = input<boolean>();

	constructor() {
		toObservable(this.profile)
			.pipe(
				filter((profile) => profile !== null),
				takeUntilDestroyed()
			)
			.subscribe({
				next: (profile) => {
					const form: FormGroup = this.form();

					if (form.touched) {
						const dateOfBirth: string | null = this.profile().dateOfBirth ? (this.profile().dateOfBirth?.slice(0, 10) as string) : null;

						form.get('firstName')?.setValue(profile.firstName);
						form.get('lastName')?.setValue(profile.lastName);
						form.get('preferredName')?.setValue(profile.preferredName);
						form.get('dateOfBirth')?.setValue(dateOfBirth);
						form.get('pronoun')?.setValue(profile.pronounID);
						form.get('gender')?.setValue(profile.genderID);
						form.get('userImage')?.setValue(profile.userImage);

						form.get('primaryEmail')?.setValue(profile.username);
						form.get('personalEmail')?.setValue(profile.email);
						form.get('phoneNumber')?.setValue(profile.phone);

						form.get('streetAddress')?.setValue(profile.streetAddress);
						form.get('streetAddress2')?.setValue(profile.streetAddress2);
						form.get('city')?.setValue(profile.city);
						form.get('state')?.setValue(profile.state);
						form.get('postalCode')?.setValue(profile.postalCode);
						form.get('country')?.setValue(profile.country);
						form.get('timezone')?.setValue(profile.timeZone?.timeZoneID);

						form.get('graduationYear')?.setValue(profile.highSchoolGraduationYear);
						form.get('educationLevel')?.setValue(profile.educationLevelID);
						form.get('currentSchool')?.setValue(profile.currentSchool);

						form.get('learningNeeds')?.setValue(profile.learningNeeds);
						form.get('bio')?.setValue(profile.bio);

						form.markAsPristine();
						form.markAsUntouched();
					}
				}
			});
	}
}
